import { render } from "./DashboardTraffic.vue?vue&type=template&id=35206e32"
import script from "./DashboardTraffic.vue?vue&type=script&lang=js"
export * from "./DashboardTraffic.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__